// @ts-nocheck
import React, { FC, useEffect, useState } from "react";
import { PageProps } from "../Page.model";
import {
  IonButton,
  IonContent,
  IonPage,
  IonList,
  IonItem,
  IonCard,
  IonBadge,
  IonCardHeader,
  IonCardTitle,
  IonCardSubtitle,
  IonCardContent,
  IonIcon,
  useIonToast,
} from "@ionic/react";
import { copyOutline } from 'ionicons/icons';
import { PaymentInfo } from "../../components";
import './Offers.css'
import { useRecoilValue, useSetRecoilState } from "recoil";
import { userState } from "../../atoms";
import { whichAuth as getAuth } from "../../getAuth";
import { offerState } from "../../atoms";
import { REST_API_URL } from '../../constants/global';
import { handleErrors } from "../../utils/handleErrors";

const services = ['Electricity','Gas','Internet'];

export const getOffers = async user => getAuth()?.currentUser?.getIdToken().then(token =>
  Promise.all(services.map(service => 
    fetch(user?._links?.self?.href + '/offers?service=' + service, {headers: {'Authorization': 'Bearer ' + token}})
      .then(handleErrors)
      .catch(error => console.log('Failed to retrieve offers for ' + service)))
  )
  .then(offers => offers.filter(offer => offer))
);

const Offers: FC<PageProps> = ({ show }) => {
  
  const [present] = useIonToast();
  const user = useRecoilValue(userState);
  const offers = useRecoilValue(offerState);
  const setOffers = useSetRecoilState(offerState);
  
  const [sortedServices, setSortedServices] = useState(services);
  const [serviceRedirectsExist, setServiceRedirectsExist] = useState([false,false,false]);

  const getRedirectsExist = () => {
    getAuth()?.currentUser?.getIdToken().then(token => {
      Promise.all(services.map(service => 
        fetch(user?._links?.self?.href + '/invoiceRedirects/' + service + '/exists', {headers: {'Authorization': 'Bearer ' + token}})
          .then(handleErrors)
          .catch(() => console.log('Failed to retrieve offers for ' + service)))
      )
      .then(results => setServiceRedirectsExist(results));
    });
  }
  
  const updateStatus = (status, offerToUpdate) => getAuth()?.currentUser?.getIdToken().then(token =>
    Promise.all(offers.map(offer => {
      if((offerToUpdate && offerToUpdate.id !== offer.id)
        || (!(offer.status === 'NEW' && status === 'VIEWED') && !(offer.status === 'VIEWED' && status === 'CLICKED'))) {
        return Promise.resolve(offer);
      } else {
        return fetch(REST_API_URL + '/offers/' + offer.id, {
            method: 'PATCH',
            headers: {
              'Authorization': 'Bearer ' + token,
              'Content-Type': 'application/merge-patch+json'
            },
            body: JSON.stringify({ 'status' : status })
          })
          .then(handleErrors);
      }
    }))
    .then(updatedOffers => setOffers(updatedOffers))
    .catch(() => console.error('Failed to update offer status.')));

  // sort services to display offers from highest potential saving to lowest
  useEffect(() => {
    var sortedOffers = offers.slice(); // create copy of offers array
    sortedOffers.sort((offer1,offer2) => Number(offer2.savingAmountAnnual) - Number(offer1.savingAmountAnnual));
    const orderedServices = sortedOffers.map(offer => offer.service);
    services.forEach(service => !orderedServices.includes(service) && orderedServices.push(service));
    setSortedServices(orderedServices);
    }, [offers]);
  
  useEffect(() => user && getRedirectsExist(), [user]);
  
  useEffect(() => show && updateStatus('VIEWED'), [show]);
  
  return show && (
    <IonPage>
      <PaymentInfo />
        <IonContent>
          <IonList lines="none">
          { sortedServices
            .map(service => offers.find(offer => service === offer?.service) || {'service':service})
            .map(offer =>
              <IonItem key={offer.service}>
                <IonCard color={offer.id ? '' : 'light'} className="offer-card">
                    { offer.id ?
                      <>
                        <IonCardHeader>
                          <img src={offer.providerLogoUrl} className="offer-logo"/>
                          <IonBadge color="warning" className="offer-badge">
                            Save ${offer.savingAmountAnnual} / year
                          </IonBadge>
                          <IonCardTitle>{offer.service}</IonCardTitle>
                          <IonCardSubtitle><img href={offer.providerLogoUrl} /> {offer.providerPlan}</IonCardSubtitle>
                        </IonCardHeader>
                        <IonCardContent>
                          <p>
                            Save <b>${offer.savingAmountAnnual}</b> per year on your {offer.service} account
                            by switching to {offer.provider}'s {offer.providerPlan} plan.
                            That's <b>{offer.savingPercent}%</b> less than your current bill.
                          </p>
                          <IonButton onClick={() => updateStatus('CLICKED', offer)} href={offer.link} target="_blank">More info</IonButton>
                        </IonCardContent>
                      </>
                      : 
                      <>
                      { serviceRedirectsExist[services.findIndex(service => service === offer.service)] ?
                        <>
                          <IonCardHeader>
                            <IonCardTitle>You're on the best {offer.service} plan</IonCardTitle>
                            <IonCardSubtitle></IonCardSubtitle>
                          </IonCardHeader>
                          <IonCardContent>
                            <p>We're monitoring the market and we will let you know as soon as we find a better {offer.service} deal for you.</p>
                          </IonCardContent>
                        </>
                        :
                        <>
                          <IonCardHeader>
                            <IonCardTitle>Get the best {offer.service} deal</IonCardTitle>
                            <IonCardSubtitle></IonCardSubtitle>
                          </IonCardHeader>
                          <IonCardContent>
                            <p>Send your {offer.service} bills to &nbsp;
                            <a onClick={() => {navigator.clipboard.writeText(user.billingEmail); present('email address copied', 3000)}}>
                              {user.billingEmail} <IonIcon icon={copyOutline}/>
                            </a> &nbsp;
                            and we'll let you know as soon as we find a better deal for you.</p>
                          </IonCardContent>
                        </>
                      }
                      </>
                  }
              </IonCard>
            </IonItem>
          )}
          </IonList>
        </IonContent>
    </IonPage>
  )
}

export default Offers
